export default {
  title: "SE OOB"
  , form: {
    nombre: {
      label: "Nombre"
      , th: "Nombre"
    }
    , nombrePersonaContacto: { label: "Nombre de Contacto" }
    , cuit: {
      label: "CUIT"
      , th: "CUIT"
    }
    , direccion: { label: "Dirección" }
    , altura: { label: "Altura" }
    , provincia: {
      label: "Provincia"
      , th: "Provincia"
    }
    , localidad: {
      label: "Localidad"
      , th: "Localidad"
    }
    , referencia: { label: "Referencia" }
    , cp: { label: "Código Postal" }
    , email: {
      label: "Email"
      , th: "Email"
    }
    , telefono: {
      label: "Teléfono"
      , th: "Teléfono"
    }
    , latitud: { label: "Latitud" }
    , longitud: { label: "Longitud" }
    , geoRelevancia: { label: "Geo-Relevancia" }
  }
  , photos: "Galería de Imágenes"
  , filters: {
    cuit: "CUIT"
    , nombre: "Nombre"
    , nombrePersonaContacto: "Nombre de Contacto"
    , provincia: "Provincia"
    , localidad: "Localidad"
    , estatus: "Estatus"
  }
  , rules: {
    requerido: { text: "El valor es requerido" }
    , geoRelevancia: { text: "El valor debe de estar entre 0 y 1" }
  }
  , errors: {
    BD5015: { text: "Ocurrió un error en el catálogo de SE OOB" }
    , WS5015: { text: "Ocurrió un error en el catálogo de SE OOB" }
    , JS5015: { text: "Ocurrió un error en el catálogo de SE OOB" }
    , CR5015: { text: "Ocurrió un error en el catálogo de SE OOB" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/seOOB.js